import React from 'react'
import PropTypes from 'prop-types'
import ErrorDisplay from '../ErrorDisplay'
import './StripeCardForm.css'
import 'font-awesome/css/font-awesome.css'

class StripeCardForm extends React.Component {

    static propTypes = {
        disabled: PropTypes.bool.isRequired,
        stripeElementType: PropTypes.string.isRequired,
        stripeElementStyle: PropTypes.object.isRequired,
        stripeApiKey: PropTypes.string.isRequired,
        addPaymentMethod: PropTypes.func.isRequired
    }

    static defaultProps = {
        stripeElementType: 'card',
        stripeElementStyle: {
            base: {
                color: '#32325d',
                lineHeight: '24px',
                fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
                fontSmoothing: 'antialiased',
                fontSize: '16px',
                '::placeholder': {
                    color: '#aab7c4'
                }
            },
            invalid: {
                color: '#fa755a',
                iconColor: '#fa755a'
            }
        }
    }

    constructor(props) {
        super(props)
        this.state = {
            errorMessage: ''
        }
        this.stripe = window.Stripe(props.stripeApiKey)
        this.stripeElements = this.stripe.elements()
        this.stripeElement = this.stripeElements.create(props.stripeElementType, props.stripeElementStyle)

        this.submit = this.submit.bind(this)
    }

    componentDidMount() {
        this.stripeElement.mount(this.stripeDiv)
        this.stripeElement.on('change', (error) => {
            this.setState({errorMessage: (error.error ? error.error.message : '')})
        })
        this.stripeElement.focus()
    }

    componentWillUnmount() {
        this.stripeElement.destroy()
    }

    render() {
        return (
            <form className="form" id="payment-form" onSubmit={this.submit}>
                <div id="card-div" disabled={this.props.disabled}>
                    <div id="card-element" ref={(input) => {
                        this.stripeDiv = input
                    }}/>
                    <div id="card-error">{this.state.errorMessage}</div>
                </div>
                <ErrorDisplay err={this.props.err}/>
                <p className="submit">
                    <button className="submitDomain" type="submit" disabled={this.props.disabled}>
                        <i className="fa fa-arrow-right fa-lg"/>
                    </button>
                </p>
            </form>
        )
    }

    submit(evt) {
        evt.preventDefault()
        this.props.addPaymentMethod(this.stripe, this.stripeElement)
    }
}

export default StripeCardForm


// WEBPACK FOOTER //
// ./src/components/StripeCardForm/StripeCardForm.js